const TWILIO_TYPES = {
    UPDATE_CLIENT: "UPDATE_CLIENT",
    UPDATE_TOKEN:"UPDATE_TOKEN",
    SESSION_LOGOUT:"SESSION_LOGOUT"
  };
  
  
  export default TWILIO_TYPES;
  